/**
 * Global Call For Price — opens contact page in a new tab.
 * URL: window.theme.callForPriceUrl (set in theme-setup.liquid)
 */
(function () {
  var DEFAULT_URL =
    "https://www.icilylive.co.za/policies/contact-information";

  function getContactUrl() {
    return (
      (window.theme && window.theme.callForPriceUrl) || DEFAULT_URL
    );
  }

  function openContactPage(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    window.open(getContactUrl(), "_blank", "noopener,noreferrer");
  }

  function textMatchesCallForPrice(text) {
    var normalized = (text || "").replace(/\s+/g, " ").trim().toLowerCase();
    var labels = [
      "call for price",
      "request a quote",
      "request price",
      "get a quote",
    ];

    for (var i = 0; i < labels.length; i++) {
      if (normalized.indexOf(labels[i]) === 0) {
        return true;
      }
    }

    return false;
  }

  function resolveCallForPriceTrigger(target) {
    if (!target || !target.closest) return null;

    var explicit = target.closest(
      "[data-call-for-price], [data-call-for-price-active]"
    );

    if (explicit) {
      if (
        explicit.matches("[data-add-to-cart]") &&
        explicit.getAttribute("data-call-for-price-active") !== "true"
      ) {
        return null;
      }

      return explicit;
    }

    var appTrigger = target.closest(
      ".call-for-price-btn, .cfp-prod-wrapper-detail"
    );

    if (appTrigger) {
      return (
        target.closest("a, button, [role='button']") ||
        appTrigger.querySelector("a, button, [role='button']") ||
        appTrigger
      );
    }

    var listingButton = target.closest(
      ".product-item__quick-add[data-call-for-price]"
    );

    if (listingButton) {
      return listingButton;
    }

    var interactive = target.closest("a, button, [role='button']");

    if (!interactive) return null;

    if (
      interactive.matches(
        'button[type="submit"][name="add"]:not([data-call-for-price-active])'
      )
    ) {
      return null;
    }

    if (
      interactive.matches("[data-add-to-cart]") &&
      interactive.getAttribute("data-call-for-price-active") !== "true"
    ) {
      return null;
    }

    var scope = interactive.closest(
      ".product-item, .product-form, .shopify-app-block, .quick-product, .sticky-atc-bar, .product__blocks, .product-blocks"
    );

    if (scope && textMatchesCallForPrice(interactive.textContent)) {
      return interactive;
    }

    return null;
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger = resolveCallForPriceTrigger(event.target);

      if (!trigger) return;

      openContactPage(event);
    },
    true
  );
})();
